import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const labelStyle = { fontSize: 12, fontWeight: 600, marginBottom: 2, display: "block", color: "#1f2937" };
const inpStyle = {
  width: "100%", padding: "6px 8px", fontSize: 13, border: "1px solid #9ca3af",
  borderRadius: 3, boxSizing: "border-box", background: "#fff",
};

const JurisEvolutionConfigModal = ({ onClose, showPopup }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [cfg, setCfg] = useState({
    base_url: "", auth_url: "", active_env: "test",
    entity_test: "", entity_prod: "", matter_status: "",
    api_key_test_set: false, api_key_prod_set: false, app_key_set: false,
    client_key_set: false, bearer_set: false, configured: false,
    matter_type_name: "", client_role: "", language: "",
  });
  // Secrets : champs vides = inchangés.
  const [apiKeyTest, setApiKeyTest] = useState("");
  const [apiKeyProd, setApiKeyProd] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/jurisevolution-config`);
        setCfg(data);
      } catch (e) {
        showPopup?.("Impossible de charger la configuration JurisÉvolution.", "error", "JurisÉvolution");
      } finally {
        setLoading(false);
      }
    })();
  }, [showPopup]);

  const persist = async () => {
    const body = {
      auth_url: cfg.auth_url || "",
      active_env: cfg.active_env || "test",
      entity_test: cfg.entity_test || "",
      entity_prod: cfg.entity_prod || "",
      base_url_test: cfg.base_url_test || "",
      base_url_prod: cfg.base_url_prod || "",
      matter_status: cfg.matter_status || "",
      matter_type: cfg.matter_type_name || "",
    };
    if (apiKeyTest.trim()) body.api_key_test = apiKeyTest.trim();
    if (apiKeyProd.trim()) body.api_key_prod = apiKeyProd.trim();
    const { data } = await axios.put(`${API}/admin/jurisevolution-config`, body);
    return data;
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const data = await persist();
      // Rafraîchit l'affichage (indicateurs « défini ») sans fermer la fenêtre.
      try {
        const { data: fresh } = await axios.get(`${API}/admin/jurisevolution-config`);
        setCfg(fresh); setApiKeyTest(""); setApiKeyProd("");
      } catch (_) { /* ignore */ }
      showPopup?.(
        data?.configured
          ? "Configuration JurisÉvolution enregistrée. L'intégration est active."
          : "Configuration enregistrée. L'environnement actif a besoin d'une Entity et d'une clé API.",
        data?.configured ? "success" : "warning",
        "JurisÉvolution"
      );
    } catch (e) {
      showPopup?.(e?.response?.data?.detail || "Échec de l'enregistrement.", "error", "JurisÉvolution");
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async (env) => {
    setTesting(true);
    setTestResult(null);
    try {
      // Enregistre d'abord les valeurs saisies, puis teste l'environnement demandé.
      await persist();
      const { data } = await axios.post(`${API}/admin/jurisevolution-test`, null, { params: env ? { env } : {} });
      setTestResult(data);
      try {
        const { data: fresh } = await axios.get(`${API}/admin/jurisevolution-config`);
        setCfg(fresh); setApiKeyTest(""); setApiKeyProd("");
      } catch (_) { /* ignore */ }
    } catch (e) {
      setTestResult({ success: false, message: e?.response?.data?.detail || "Échec du test de connexion.", raw: String(e) });
    } finally {
      setTesting(false);
    }
  };

  const secretPh = (isSet) => (isSet ? "•••••••• (défini — laisser vide pour conserver)" : "Non défini");

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 2000 }}
         data-testid="je-config-overlay">
      <div style={{ background: "#f3f4f6", border: "2px solid #334155", width: 860, maxWidth: "96vw", maxHeight: "90vh", overflow: "auto" }}
           data-testid="je-config-modal" onClick={e => e.stopPropagation()}>
        <div style={{ background: "#003366", color: "#fff", padding: "8px 16px", fontWeight: "bold", fontSize: 14, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Configuration JurisÉvolution</span>
          <span style={{ fontSize: 12, fontWeight: 400 }}>
            {loading ? "" : (cfg.configured ? "● Active" : "○ Incomplète")}
          </span>
        </div>

        {loading ? (
          <div style={{ padding: 24, fontSize: 13 }}>Chargement…</div>
        ) : (
          <div style={{ padding: "18px 20px" }}>
            <p style={{ fontSize: 12, color: "#4b5563", marginTop: 0, marginBottom: 16 }}>
              Les clés sont disponible dans l'application JurisÉvolution dans la section
              Admin / Clé d'API et restent stockées côté serveur. Chaque environnement a sa propre
              <b> Entity</b> et sa <b>clé API</b>. L'URL du serveur est détectée
              automatiquement. Laissez une clé vide pour conserver sa valeur actuelle.
            </p>

            {/* Environnement actif pour les envois */}
            <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 6, padding: "10px 12px", marginBottom: 16 }}>
              <label style={{ ...labelStyle, marginBottom: 6 }}>Environnement actif pour les envois</label>
              {cfg.active_env_forced ? (
                <div data-testid="je-env-auto">
                  <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
                    <span style={{
                      display: "inline-block", padding: "2px 10px", borderRadius: 12, fontWeight: 700,
                      fontSize: 12, color: "#fff",
                      background: cfg.active_env === "prod" ? "#b91c1c" : "#1e40af",
                    }}>
                      {cfg.active_env === "prod" ? "PRODUCTION" : "Formation / Test"}
                    </span>
                    <span style={{ color: "#4b5563" }}>
                      déterminé automatiquement par le déploiement{cfg.app_env ? ` (APP_ENV = « ${cfg.app_env} »)` : ""}
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: "#9a3412", marginTop: 6 }}>
                    Aucune manipulation manuelle : l'environnement de développement envoie vers <b>Formation / Test</b> et
                    l'environnement de production envoie vers <b>Production</b>. Les clés des deux environnements se configurent ci-dessous.
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: "flex", gap: 18 }}>
                    <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                      <input type="radio" name="je-env" checked={cfg.active_env !== "prod"}
                             onChange={() => setCfg({ ...cfg, active_env: "test" })} data-testid="je-env-test" />
                      Formation / Test
                    </label>
                    <label style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                      <input type="radio" name="je-env" checked={cfg.active_env === "prod"}
                             onChange={() => setCfg({ ...cfg, active_env: "prod" })} data-testid="je-env-prod" />
                      <b style={{ color: "#b91c1c" }}>Production</b>
                    </label>
                  </div>
                  <div style={{ fontSize: 11, color: "#9a3412", marginTop: 6 }}>
                    Le bouton « Envoyer vers JurisÉvolution » enverra les dossiers vers l'environnement coché ici.
                  </div>
                </>
              )}
            </div>

            {/* Profils Formation/Test et Production côte à côte */}
            <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              {/* Profil Formation / Test */}
              <div style={{ flex: 1, border: "1px solid #bfdbfe", borderRadius: 6, padding: "10px 12px", background: "#eff6ff" }}>
                <div style={{ fontWeight: 700, fontSize: 12, color: "#1e40af", marginBottom: 8 }}>Environnement Formation / Test</div>
                <div style={{ marginBottom: 10 }}>
                  <label style={labelStyle}>Entity (Test)</label>
                  <input style={inpStyle} value={cfg.entity_test || ""} data-testid="je-entity-test"
                         onChange={e => setCfg({ ...cfg, entity_test: e.target.value })} placeholder="Entity de l'environnement de formation" />
                </div>
                <div>
                  <label style={labelStyle}>Clé API (Test) {cfg.api_key_test_set && <span style={{ color: "#059669" }}>✓</span>}</label>
                  <input style={inpStyle} type="password" value={apiKeyTest} data-testid="je-apikey-test"
                         onChange={e => setApiKeyTest(e.target.value)} placeholder={secretPh(cfg.api_key_test_set)} autoComplete="new-password" />
                </div>
                <div style={{ marginTop: 10 }}>
                  <label style={labelStyle}>URL API métier (Test)</label>
                  <input style={inpStyle} value={cfg.base_url_test || ""} data-testid="je-baseurl-test"
                         onChange={e => setCfg({ ...cfg, base_url_test: e.target.value })}
                         placeholder="https://dlxe.api.3emanagement.com/dlxeNN/JEWebApi" />
                </div>
              </div>

              {/* Profil Production */}
              <div style={{ flex: 1, border: "1px solid #fecaca", borderRadius: 6, padding: "10px 12px", background: "#fef2f2" }}>
                <div style={{ fontWeight: 700, fontSize: 12, color: "#b91c1c", marginBottom: 8 }}>Environnement Production</div>
                <div style={{ marginBottom: 10 }}>
                  <label style={labelStyle}>Entity (Production)</label>
                  <input style={inpStyle} value={cfg.entity_prod || ""} data-testid="je-entity-prod"
                         onChange={e => setCfg({ ...cfg, entity_prod: e.target.value })} placeholder="Entity de l'environnement de production" />
                </div>
                <div>
                  <label style={labelStyle}>Clé API (Production) {cfg.api_key_prod_set && <span style={{ color: "#059669" }}>✓</span>}</label>
                  <input style={inpStyle} type="password" value={apiKeyProd} data-testid="je-apikey-prod"
                         onChange={e => setApiKeyProd(e.target.value)} placeholder={secretPh(cfg.api_key_prod_set)} autoComplete="new-password" />
                </div>
                <div style={{ marginTop: 10 }}>
                  <label style={labelStyle}>URL API métier (Production)</label>
                  <input style={inpStyle} value={cfg.base_url_prod || ""} data-testid="je-baseurl-prod"
                         onChange={e => setCfg({ ...cfg, base_url_prod: e.target.value })}
                         placeholder="https://dlxe.api.3emanagement.com/dlxeNN/JEWebApi" />
                </div>
              </div>
            </div>

            {/* Paramètres partagés */}
            <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Type de dossier</label>
                <input style={inpStyle} value={cfg.matter_type_name || ""} data-testid="je-matter-type"
                       onChange={e => setCfg({ ...cfg, matter_type_name: e.target.value })}
                       placeholder="Gestion admissibilité" />
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }} data-testid="je-matter-type-note">
                  Libellé EXACT du type de dossier envoyé à JurisÉvolution (accents, majuscules,
                  espaces). Par défaut : « Gestion admissibilité ».
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Statut du dossier</label>
                <input style={inpStyle} value={cfg.matter_status || ""} data-testid="je-matter-status"
                       onChange={e => setCfg({ ...cfg, matter_status: e.target.value })}
                       placeholder="DAJ à compléter" />
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }} data-testid="je-matter-status-note">
                  Libellé EXACT du statut tel qu'il apparaît dans JurisÉvolution
                  (accents, majuscules, espaces). Par défaut : « DAJ à compléter ».
                </div>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={labelStyle}>URL d'authentification (hub API)</label>
              <input style={inpStyle} value={cfg.auth_url || ""} data-testid="je-auth-url"
                     onChange={e => setCfg({ ...cfg, auth_url: e.target.value })}
                     placeholder="https://ijpq.api.3emanagement.com/hub/web" />
              <div style={{ fontSize: 11, color: "#b45309", marginTop: 4, lineHeight: 1.4 }}>
                ⚠ Utiliser le <b>hub API</b> (avec « <b>.api.</b> »), p. ex.
                <code style={{ background: "#fff7ed", padding: "0 3px", borderRadius: 3 }}> https://ijpq.api.3emanagement.com/hub/web</code>.
                Ce n'est <b>pas</b> l'adresse de l'application (<code>ijpq.3emanagement.com</code>)
                ni la page SSO (<code>aidejuridique.jurisevolution.ca</code>), qui servent à la
                connexion humaine par navigateur et renvoient une erreur ici.
              </div>
            </div>

            <div style={{ background: "#eef2ff", border: "1px solid #c7d2fe", borderRadius: 4, padding: "8px 12px", fontSize: 11, color: "#3730a3", marginBottom: 16 }}>
              Valeurs fixes : type de dossier « {cfg.matter_type_name} », rôle « {cfg.client_role} », langue « {cfg.language} ». URL du serveur métier détectée automatiquement.
            </div>

            {testResult && (
              <div data-testid="je-test-result" style={{
                border: `1px solid ${testResult.success ? "#86efac" : "#fca5a5"}`,
                background: testResult.success ? "#f0fdf4" : "#fef2f2",
                borderRadius: 6, padding: "10px 12px", marginBottom: 16, fontSize: 12,
              }}>
                <div style={{ fontWeight: "bold", color: testResult.success ? "#15803d" : "#b91c1c", marginBottom: 6 }}>
                  {testResult.success ? "✓ Connexion réussie" : "✗ Échec de la connexion"}
                </div>
                <div style={{ color: "#374151", marginBottom: 8 }}>{testResult.message}</div>
                <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                  <table style={{ fontSize: 11, color: "#4b5563", borderCollapse: "collapse", flex: "0 0 auto" }}>
                    <tbody>
                      {testResult.step && (
                        <tr><td style={{ paddingRight: 10, fontWeight: 600 }}>Étape</td><td>{testResult.step}</td></tr>
                      )}
                      {testResult.http_status != null && (
                        <tr><td style={{ paddingRight: 10, fontWeight: 600 }}>Code HTTP</td><td data-testid="je-test-http">{testResult.http_status}</td></tr>
                      )}
                      {testResult.url && (
                        <tr><td style={{ paddingRight: 10, fontWeight: 600, verticalAlign: "top" }}>URL</td><td style={{ wordBreak: "break-all", maxWidth: 320 }}>{testResult.url}</td></tr>
                      )}
                    </tbody>
                  </table>
                  {testResult.raw ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, color: "#4b5563", marginBottom: 4 }}>Réponse brute :</div>
                      <pre data-testid="je-test-raw" style={{
                        margin: 0, maxHeight: 120, overflow: "auto", background: "#111827", color: "#e5e7eb",
                        padding: "8px 10px", borderRadius: 4, fontSize: 11, whiteSpace: "pre-wrap", wordBreak: "break-word",
                      }}>{testResult.raw}</pre>
                    </div>
                  ) : null}
                </div>
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
              <div style={{ display: "flex", gap: 8 }}>
                <button className="win-btn" onClick={() => handleTest("test")} disabled={testing || saving} data-testid="je-config-test-test"
                        style={{ padding: "6px 14px", fontSize: 12 }}>
                  {testing ? "Test…" : "Tester (Formation)"}
                </button>
                <button className="win-btn" onClick={() => handleTest("prod")} disabled={testing || saving} data-testid="je-config-test-prod"
                        style={{ padding: "6px 14px", fontSize: 12 }}>
                  {testing ? "Test…" : "Tester (Production)"}
                </button>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button className="win-btn" onClick={onClose} data-testid="je-config-close"
                        style={{ padding: "6px 18px", fontSize: 12 }}>Fermer</button>
                <button className="win-btn" onClick={handleSave} disabled={saving || testing} data-testid="je-config-save"
                        style={{ padding: "6px 18px", fontSize: 12, fontWeight: "bold" }}>
                  {saving ? "Enregistrement…" : "Enregistrer"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JurisEvolutionConfigModal;
